module.exports = __webpack_public_path__ + "img/kubrickheader.00fe374f.jpg";